import {
    CREATE_RECIPE,
    CREATE_RECIPE_FAILED,
    RESET_FORMS
} from '../actions/types'

const initialState = {}

const createRecipeReducer = (state = initialState, action) => {
    switch(action.type){
        case CREATE_RECIPE:
            return {
                details: action.payload,
                success: 'Recipe created successfully',
            }
        case CREATE_RECIPE_FAILED:
            return {
                ...state,
                errors: action.payload,
                success: null
            }
        case RESET_FORMS:
            return initialState
        default:
            return state
    }
}

export default createRecipeReducer